export const GET_PRIVACY = 'API_FETCH__GET_PRIVACY';
export const POST_PRIVACY = 'API_FETCH__POST_PRIVACY';
export const GET_SOLUTIONS = 'API_FETCH__GET_SOLUTIONS';

export const VERSIONS__SET_VERSIONS_LIST = 'VERSIONS__SET_VERSIONS_LIST';
export const VERSIONS__SET_SOLUTIONS = 'VERSIONS__SET_SOLUTIONS';
export const VERSIONS__CLEAR_VERSIONS = 'VERSIONS__CLEAR_VERSIONS';
export const VERSIONS__CREATE_VERSIONS = 'VERSIONS__CREATE_VERSIONS';
